(function (angular) {
  angular.module("app").directive("comments", commentsDirective);

  commentsDirective.$inject = [
    "UsersApi",
    "thisUser",
    "settings",
    "CommentsApi",
    "$rootScope",
    "$interpolate",
  ];

  function commentsDirective(
    UsersApi,
    thisUser,
    CommentsApi,
    settings,
    $rootScope,
    $interpolate,
  ) {
    function link($scope, element, attrs) {
      // console.log($scope)
      // console.log(element)
      // console.log(attrs, attrs.itemType)

      $scope.itemId = $scope.itemId || null;
      $scope.itemType = $scope.itemType || attrs.itemType;
      $scope.ref = $scope.ref;
      $scope.comments = $scope.comments || [];
      $scope.surfaceComments = $scope.comments.length
        ? $scope.comments.filter((x) => x.parent_id !== null)
        : [];

      if ($scope.itemType && $scope.itemType.startsWith("_")) {
        $scope.itemType = $scope.itemType.replace("_", "");
      }

      $scope.commentsLoading = false;
      $scope.replyBoxOpen = false;
      $scope.replyText = "";
      $scope.replying = false;

      $scope.editedComment = $scope.comment;

      $scope.rootElement = element;

      const replyFormat = {
        parent_id: "",
        body: "",
        entities: [],
        item_id: $scope.itemId,
        item_type: $scope.itemType,
      };

      $scope.reply = replyFormat;
      $scope.postComment = postComment;

      const usersFilter = {
        filter_by: null,
        order_by: "created_at",
        order: "desc",
        user_id: null,
      };

      const getCommentsFilter = {
        filter_by: null,
        order_by: "created_at",
        order: "desc",
        user_id: null,
        item_id: $scope.itemId,
      };

      enum API_ROUTE {
        COMMENTS = "/api/comments",
      }

      $scope.$watchCollection("comments", (newComments, oldComments) => {
        if ($scope.comments.length) {
          $scope.surfaceComments = $scope.comments.filter(
            (c) => c.parent_id == null,
          );
          $scope.replies = $scope.comments.filter((c) => c.parent_id != null);
          $scope.commentsLoading = false;
        }
      });

      function $transform(list: object[]) {
        const handleSuccess = (response) => {
          const { data } = response;

          list.map((item: any) => {
            const user = data.find((x) => x.id === item.user_id);

            if (user) {
              const { id, full_name, slug, img } = user;
              item["user"] = { id, full_name, slug, img };
            }
          });

          return list;
        };

        UsersApi.get(usersFilter, handleSuccess);
        return list ?? [];
      }

      function getComments(): void {
        $scope.commentsLoading = true;
        fetch(API_ROUTE.COMMENTS + "?item_id=" + $scope.itemId, {
          method: "GET",
        })
          .then((res) => res.json())
          .then((response) => {
            const { data } = response;
            $scope.comments = data.length ? $transform(data) : [];
            $scope.commentsLoading = false;
          });
      }

      async function updateComment(fetchMethod, commentData): Promise<any> {
        if (fetchMethod === "GET") return false;

        const { id, parentId, itemId, body, entities = [] } = commentData;
        let endpoint = `${API_ROUTE.COMMENTS}`;

        switch (fetchMethod.toUpperCase()) {
          case "DELETE":
            endpoint = `${endpoint}/${id}`;
            break;
          case "PUT":
            endpoint = `${endpoint}/${id}?body=${body}`; // IMPLEMENT ENTITIES HERE
            break;
          case "POST":
            endpoint = `${endpoint}?item_type=${$scope.itemType}&item_id=${itemId}&body=${body}`;
            if (parentId) endpoint = `${endpoint}&parent_id=${parentId}`;
            break;
          default:
            throw Error(
              "[updateComment] Unexpected fetchMethod: " + fetchMethod,
            );
        }

        const promise = await fetch(endpoint, { method: fetchMethod }).then(
          (res) => res.json(),
        );
        return promise;
      }

      function postComment() {
        if ($scope.reply.body) {
          let { id = null, item_id, body } = $scope.reply;
          const method = id != null ? "PUT" : "POST";

          $scope.reply.saving = true;

          updateComment(method, { itemId: item_id, body }).then((res) => {
            $scope.reply = replyFormat;
            $scope.reply.body = "";
            $scope.reply.saving = false;
            getComments();
          });

          $scope.reply.saving = false;
        }
      }

      function bootstrap() {
        $scope.isLoading = false;

        if ($scope.rootElement) {
          $scope.rootElement[0].addEventListener(
            "comments:refresh",
            getComments,
            false,
          );
        }

        if (!$scope.comments.length) {
          getComments();
        }
      }

      bootstrap();
    }

    return {
      restrict: "E",
      templateUrl: "directives/comments.html",
      transclude: true,
      replace: true,
      link: link,
      scope: {
        comments: "=?",
        itemId: "=",
        itemType: "=",
        ref: "=",
      },
    };
  }
})(angular);
